import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Badge,
  Form,
  Table,
} from "react-bootstrap";
import { studyEventFormSchemaServices } from "../../../../APIServices/studyEventFormSchemaServices";
import { useParams } from "react-router";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import { studyEventManagementServices } from "../../../../APIServices/CTMS/EventManagement/studyEventManagementServices";
import Swal from "sweetalert2";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const SpecialFormAssignment = () => {
  const [eventRows, setEventRows] = useState([]);
  const [schemaId, setSchemaId] = useState("");
  const [formList, setFormList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [leftLoading, setLeftLoading] = useState(false);
  const [rightLoading, setRightLoading] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [eventSchema, setEventSchema] = useState([]);
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [addedForms, setAddedForms] = useState([]);
  const [visitsData, setVisitsData] = useState([]);
  const [selectedVisit, setSelectedVisit] = useState("");

  const handleAddForm = (form) => {
    if (
      !addedForms.some((item) => {
        const sameForm =
          item.formId === form.formId &&
          item.formVersion === form.version &&
          item.studyId === studyId &&
          item.schemaId === schemaId;
        if (!sameForm) return false;
      })
    ) {
      setAddedForms((prev) => [
        ...prev,
        {
          formId: form.formId,
          formVersion: form.version,
          studyId,
          schemaId,
        },
      ]);
    }
  };

  const handleRemoveForm = (formId) => {
    setAddedForms((prev) =>
      prev.filter((item) => item.formId !== formId)
    );
  };

  const assignUnassignStudySpecialForm = async (
    form,
    type
  ) => {
    setButtonLoader(true);
    let userData = {};
    userData.studyId = studyId;
    userData.schemaId = schemaId;
    userData.formId = form?.formId;
    userData.formVersion = form?.version || form?.formVersion;
    userData.type = type;
    let data = await studyEventManagementServices.assignUnassignStudySpecialForm(
      userData
    );
    if (data?.statusCode === 200) {
      if (type === "assigne") {
        handleAddForm(form);
      } else {
        handleRemoveForm(
          form.formId,
          form.formVersion,
          form.eventId,
          form.timepointUniqueId
        );
      }
    }
    setButtonLoader(false);
  };

  const getEventFormSchema = async (e) => {
    let data = await studyEventFormSchemaServices.getEventFormSchema(
      "active",
      studyId
    );
    setEventSchema(data?.data || []);
    setSchemaId(data?.data?.[0]?.schemaId || "");
  };

  const getStudyLevelFormAllVersion = async (e) => {
    setRightLoading(true);
    let data = await studyLevelFormManagementServices.getStudyLevelFormAllVersion(
      studyId, "specialForm", StudyMode
    );
    setFormList(data?.data || []);
    setRightLoading(false);
  };

  const getSpecialEventFormBySchema = async (e) => {
    setLeftLoading(true);
    let data = await studyEventManagementServices.getSpecialEventFormBySchema(
      studyId,
      schemaId,
    );
    setAddedForms(data?.data || []);
    setLeftLoading(false);
  };

  useEffect(() => {
    if (schemaId) {
      getSpecialEventFormBySchema();
    }
  }, [schemaId]);

  useEffect(() => {
    getEventFormSchema()
    getStudyLevelFormAllVersion()
  }, []);

  const exportMatrixCSV = () => {
    const headers = ["Form", "Special Event"];
    const rows = formList.map((form) => {
      const hasForm = addedForms.some(
        (item) =>
          item.formId === form.formId &&
          item.formVersion === form.version
      );
      return [
        `"${form.formName} (v${form.version})"`,
        hasForm ? "Yes" : "",
      ];
    });
    const csvContent = [
      headers.join(","),
      ...rows.map((row) => row.join(",")),
    ].join("\n");
    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `Special_Form_Matrix_${schemaId}.csv`
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className="overflow-auto" style={{ height: "calc(100vh - 144px)" }}>
      <Container fluid className="py-3">
        <Row className="mb-3">
          <Col md={7}>
            <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
              <div className="bg-light p-2 border-bottom hstack justify-content-between">
                <span className="fw-bold">Assigned Special Form</span>{" "}
                <div className="d-flex align-items-center gap-2">
                  <Form.Label className="text-muted mb-0">Event:</Form.Label>
                  <Form.Select
                    onChange={(e) => setSchemaId(e.target.value)}
                    value={schemaId}
                    disabled={eventSchema?.length === 0}
                    size="sm" style={{ flex: 1 }}>
                    {eventSchema?.length > 0 ? (
                      eventSchema?.map((item, index) => (
                        <option
                          selected={schemaId === item?.schemaId}
                          key={index}
                          value={item?.schemaId}
                        >
                          {item?.schemaName}
                        </option>
                      ))
                    ) : (
                      <option value={""}>No Schema</option>
                    )}
                  </Form.Select>
                </div>
              </div>
              <Card.Body>
                <div className="d-flex flex-wrap gap-2">
                  {leftLoading ?
                    <PageLoader />
                    : addedForms.map((item) => {
                      const form = formList.find(
                        (f) =>
                          f.formId === item.formId &&
                          f.version === item.formVersion
                      );

                      return (
                        <Badge
                          key={`${item.formId}_${item.formVersion}_${item.eventId}_${item.timepointUniqueId || ""}`}
                          pill
                          className="hstack gap-2 text-dark"
                          bg="primary-subtle"
                        >
                          <small>
                            {form?.formName} (v{item.formVersion})
                          </small>

                          <Button
                            variant="link"
                            size="sm"
                            className="p-0 text-danger"
                            style={{ textDecoration: "none" }}
                            onClick={() => {
                              assignUnassignStudySpecialForm(
                                item,
                                "unassigne"
                              )
                            }}
                          >
                            ×
                          </Button>
                        </Badge>
                      );
                    })}
                  {addedForms.length === 0 && (
                    <div className="text-muted text-center w-100 py-3">
                      No forms added. Click a form from the library to add.
                    </div>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* Right Panel - Form Library */}
          <Col md={5}>
            <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
              <div className="bg-light p-2 border-bottom hstack justify-content-between">
                <span className="fw-bold">Form library</span>{" "}
                <span className="text-muted small">Click a form to add it to the selected visit.</span>{" "}
              </div>
              <Card.Body>
                <div
                  className="d-flex flex-wrap gap-2"
                  style={{ maxHeight: "400px", overflowY: "auto" }}
                >
                  {rightLoading ?
                    <PageLoader />
                    : formList.map((form) => {
                      const isAdded = addedForms.some(
                        (f) => f.formId === form.formId
                      );
                      return (
                        <Badge
                          key={form.formId}
                          pill
                          className="hstack gap-2 text-dark"
                          bg={(!isAdded && schemaId) ? "primary-subtle" : "secondary-subtle"}
                          style={{
                            cursor: (!isAdded && schemaId) ? "pointer" : "default",
                            opacity: (!isAdded && schemaId) ? 1 : 0.7,
                          }}
                          onClick={() => {
                            if (!isAdded && schemaId) {
                              assignUnassignStudySpecialForm(
                                form,
                                "assigne"
                              );
                            }
                          }}
                        >
                          <small>{form.formName} (v{form?.version})</small>
                          {!isAdded ? (
                            <span className="ms-1 text-primary"> + </span>
                          ) : (
                            <span className="ms-1 text-success"> ✓</span>
                          )}
                        </Badge>
                      );
                    })}
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {/* Visit × Form matrix */}
        <Row className="mb-3">
          <Col xs={12}>
            <Card className="app-card bg-light overflow-hidden shadow-sm h-100">
              <div className="bg-light p-2 hstack justify-content-between">
                <span className="fw-bold">Special Event × Form matrix</span>
                <button onClick={exportMatrixCSV} className="updateProfile" size="sm">
                  Export matrix
                </button>
              </div>
              <Card.Body className="p-0" style={{ overflowX: "auto" }}>
                {loading ?
                  <PageLoader />
                  :
                  <>
                    <Table bordered hover size="sm" className="mb-0" style={{ fontSize: "12px", minWidth: "800px" }}>
                      <thead className="position-sticky top-0 z-1">
                        <tr>
                          <th style={{ position: "sticky", left: 0, background: "#f8f9fa", zIndex: 1 }}>Form</th>
                          <th className="text-center" style={{ minWidth: "60px" }}>
                            <div>Special Event</div>
                            <div style={{ fontSize: "9px", color: "#8aa1a9" }}>Special Event</div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {formList.map((form) => {
                          const hasForm = addedForms.some(item => (item?.formId === form.formId && item?.formVersion === form.version));
                          return (
                            <tr key={form.id}>
                              <td style={{
                                position: "sticky",
                                left: 0,
                                background: "white",
                                zIndex: 1,
                                fontWeight: "500",
                                fontSize: "12px"
                              }}>
                                {form.formName} (v{form.version})
                              </td>
                              <td className="text-center">
                                {hasForm ? (
                                  <span style={{
                                    color: "#52707a",
                                    fontSize: "16px",
                                    fontWeight: "bold"
                                  }}>
                                    {"○"}
                                  </span>
                                ) : (
                                  <span style={{ color: "#d8e1e5" }}>·</span>
                                )}
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </Table>
                    <div className="d-flex gap-3 p-2" style={{ fontSize: "11px", color: "#52707a" }}>
                      <span><span style={{ color: "#52707a", fontWeight: "bold" }}>○</span> Assigned Form</span>
                      <span><span style={{ color: "#d8e1e5" }}>·</span> Not Assigned Form</span>
                    </div>
                  </>
                }
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SpecialFormAssignment;